<template>
  <div>
  <p class="modalPara mt-6">
    <strong>On-Campus During Business Hours </strong>
  </p>

  <p class="modalPara mt-6">
    If you feel you are in crisis and need to speak with someone right away, you can come to the main clinic at
    <a
        class="text-link-blue dark:text-link-light-blue font-bold pb-1"
        href="https://carleton.ca/campus/map/#TT">2600 Carleton Technology and Training Centre</a> during regular operating hours.
  </p>
  <p class="modal-Para mt-6">
    If you are unable to come into the clinic, please call Health and Counselling Services at <a
      class="text-link-blue dark:text-link-light-blue font-bold pb-1"
      href="tel:6135206674"
  >613-520-6674</a> and select option #2 to request a same-day, urgent appointment.
  </p>
  <p class="modalPara mt-6">
    Health and Counselling Services is open Monday-Friday 8:30 a.m. - 4:30 p.m. and closed during holidays.
  </p>
  <p class="modalPara mt-6">
    <strong>Off-Campus During Business Hours </strong>
  </p>

  <div role="dialog">
    <p class="modalPara mt-6">
      If you need assistance for an urgent situation outside of Health and
      Counselling Services’ regular operating hours, contact any of the following numbers for 24/7
      support:
    </p>
    <ul class="list-inside list-disc">
      <li class="ml-4">
        On-Campus: Campus Safety Services:
        <a
            class="text-link-blue dark:text-link-light-blue font-bold pb-1"
            href="tel:6135204444"
        >613-520-4444</a
        >
        (or, dial 4444 from any university land-line)
      </li>
      <li class="ml-4">
        Off-Campus: call <span class="font-bold">911</span>
      </li>
      <li class="ml-4">
        Good 2 Talk:
        <a
            class="text-link-blue dark:text-link-light-blue font-bold pb-0"
            href="tel:18669255454"
        >1-866-925-5454</a
        >
      </li>
      <li class="ml-4">
        Distress Centre of Ottawa and Region:
        <a
            class="text-link-blue dark:text-link-light-blue font-bold pb-1"
            href="tel:6132383311"
        >613-238-3311</a
        >
      </li>
      <li class="ml-4">
        Crisis Service Canada:
        <a
            class="text-link-blue dark:text-link-light-blue font-bold pb-1"
            href="tel:18334564566"
        >1-833-456-4566
        </a>
      </li>
      <li class="ml-4">
        Suicide Crisis Helpline:
        <a
            class="text-link-blue dark:text-link-light-blue font-bold pb-1"
            href="tel:988"
        >9-8-8 (call or text)
        </a>
      </li>
    </ul>
  </div>
  </div>
</template>

<script>
export default {
  name: "EmergencyContacts.vue"
}
</script>

<style scoped>

</style>